import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { initialMarginContractSlice } from './margin-contract.slice';
import { environment } from 'src/environments/environment';
import { computed } from '@angular/core';
import { MarginContract } from '../../models/margin-contract.model';

export const MarginContractStore = signalStore(
    { providedIn: 'root' },

    withState(initialMarginContractSlice),

    withComputed((store) => ({
        snapshot: computed(() => ({
            contractId: store.contractId(),
            contractStageCode: store.contractStageCode(),
            contractTypeCode: store.contractTypeCode()
        }))
    })),

    withMethods((store) => ({
        updateMarginContractFromData: (data: MarginContract) => {
            patchState(store, { ...data });
        },
        getState: () => store,
        getSnapshot: () => store.snapshot()
    })),

    environment.storeWithDevTools('locums-margin-calculator-margin-contract-store')
);
